class RoleUtil {
    static checkRole = (viewPrivileges, userRole) => {
        return viewPrivileges.length === 0 || viewPrivileges.includes(userRole);
    };
}

export default RoleUtil;
